import { UserPreferencesModel } from 'models/user-preferences/UserPreferencesModel';

export { isLoading, doneLoading } from '../config/actions';

export const SET_USER_PREFERENCES = 'user-preferences/SET_USER_PREFERENCES';
export interface SetUserPreferenceAction {
  readonly type: typeof SET_USER_PREFERENCES;
  readonly payload: Partial<UserPreferencesModel>;
}

export const RESET_USER_PREFERENCES = 'user-preferences/RESET_USER_PREFERENCES';
export interface ResetUserPreferenceAction {
  readonly type: typeof RESET_USER_PREFERENCES;
  readonly payload: ReadonlyArray<string>;
}

export type UserPreferencesAction = SetUserPreferenceAction | ResetUserPreferenceAction;

export const setUserPreferences = (preferences: Partial<UserPreferencesModel>): SetUserPreferenceAction => ({
  payload: preferences,
  type: SET_USER_PREFERENCES,
});

export const resetUserPreferences = (preferences: ReadonlyArray<string>): ResetUserPreferenceAction => ({
  payload: preferences,
  type: RESET_USER_PREFERENCES,
});
